import { CarouselWithTitle } from "@faire/retailer-visitor-shared/components/Carousel/CarouselWithTitle";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import styled from "styled-components";
export var Wrapper = styled.div.withConfig({
    componentId: "sc-556cda22-0"
})([
    "width:100%;max-width:1232px;margin:0 auto;"
]);
export var CarouselContainer = styled.div.withConfig({
    componentId: "sc-556cda22-1"
})([
    "",
    "{padding:0 56px;}",
    "{",
    "{padding-right:0;}}"
], responsiveMediaQueries.tabletAndAbove, CarouselWithTitle.AuxiliaryTitle, responsiveMediaQueries.tabletAndAbove);
